const manageCourse = {
    index:       r => require.ensure([], () => r(require('../components/list/index')),         'manage-course'),
    general:      r => require.ensure([], () => r(require('../components/list/general')),           'manage-course'),
    notification: r => require.ensure([], () => r(require('../components/list/notification')), 'manage-course'),
    completion:       r => require.ensure([], () => r(require('../components/list/completion')),       'manage-course'),
    enrolments:       r => require.ensure([], () => r(require('../components/list/enrolments')),       'manage-course'),
    settings:    r => require.ensure([], () => r(require('../components/list/settings')),      'manage-course')
};
const learningPath = r => require.ensure([], () => r(require('../components/list/learningpath')), 'manage-course');
const manageSetting = {
    index:       r => require.ensure([], () => r(require('../components/setting/index')),         'manage-setting'),
    general:      r => require.ensure([], () => r(require('../components/setting/general')),           'manage-setting'),
    gamification:      r => require.ensure([], () => r(require('../components/setting/gamification')),           'manage-setting'),
    certificate: r => require.ensure([], () => r(require('../components/setting/certificate')), 'manage-setting'),
    notificationstemplates:       r => require.ensure([], () => r(require('../components/setting/notificationstemplates')),       'manage-setting'),
    integrations:       r => require.ensure([], () => r(require('../components/setting/integrations')),       'manage-setting')
};
const editCourse = {
    editindex:       r => require.ensure([], () => r(require('../components/edit/editindex')),         'edit-course'),
    general:      r => require.ensure([], () => r(require('../components/edit/editgeneral')),           'edit-course'),
    notification: r => require.ensure([], () => r(require('../components/edit/editnotification')), 'edit-course'),
    completion:       r => require.ensure([], () => r(require('../components/edit/editcompletion')),       'edit-course'),
    enrolments:       r => require.ensure([], () => r(require('../components/edit/editenrolments')),       'edit-course')
};
import  * as component  from './components'
export default [
    {
      name: 'lms.courses',
      path: '/',
      component: component.courses,
    },
    {
      name: 'lms.courses',
      path: '/lms/courses',
      component: component.courses,
    },
    {
        name: 'lms.learningpath',
        path: '/lms/learning-path',
        component: learningPath,
    },
    {
        name: 'lms.approvals',
        path: '/lms/approvals',
        component: component.Approvals,
    },
    {
        name: 'lms.creatorapprovals',
        path: '/lms/creator-approvals',
        component: component.Approvals,
    },
    {
        name: 'lms.approvaldetail',
        path: '/lms/approvals/detail/:batchId',
        component: component.ApprovalDetail,
    },
    {
        name: 'lms.index',
        path: '/lms/general/:id',
        component: manageCourse.index,
        redirect: { name:'lms.general/:id'},
        children: [
            {
                name: 'lms.general',
                path: '/lms/general/:id',
                component: manageCourse.general,
            },
            {
                name: 'lms.notification',
                path: '/lms/notification/:id',
                component: manageCourse.notification,
            },
            {
                name: 'lms.completion',
                path: '/lms/completion/:id',
                component: manageCourse.completion,
            },
            {
                name: 'lms.enrolments',
                path: '/lms/enrolments/:id',
                component: manageCourse.enrolments,
            },
            {
                name: 'lms.settings',
                path: '/lms/settings/:id',
                component: manageCourse.settings,
            }
        ]
    },
    {
        name: 'lms.editindex',
        path: '/lms/editgeneral/:id',
        component: editCourse.editindex,
        redirect: { name:'lms.editgeneral'},
        children: [
            {
                name: 'lms.editgeneral',
                path: '/lms/editgeneral/:id',
                component: editCourse.editgeneral,
            },
            {
                name: 'lms.editnotification',
                path: '/lms/editnotification/:id',
                component: editCourse.editnotification,
            },
            {
                name: 'lms.editcompletion',
                path: '/lms/editcompletion/:id',
                component: editCourse.editcompletion,
            },
            {
                name: 'lms.editenrolments',
                path: '/lms/editenrolments/:id',
                component: editCourse.editenrolments,
            }
        ]
    },
    {
        name: 'lms.index',
        path: '/lms/setting',
        component: manageSetting.index,
        redirect: { name:'lms.setting'},
        children: [
            {
                name: 'lms.setting',
                path: '/lms/setting',
                component: manageSetting.general,
            },
            {
                name: 'lms.gamification',
                path: '/lms/gamification',
                component: manageSetting.gamification,
            },
            {
                name: 'lms.certificate',
                path: '/lms/certificate',
                component: manageSetting.certificate,
            },
            {
                name: 'lms.notificationstemplates',
                path: '/lms/notificationstemplates',
                component: manageSetting.notificationstemplates,
            },
            {
                name: 'lms.integrations',
                path: '/lms/integrations',
                component: manageSetting.integrations,
            }
        ]
    },
    {
        name: 'lms.reports',
        path: '/lms/reports',
        component: component.Reports,
    },
    {
        name: 'lms.reportcourses',
        path: '/lms/reports/courses',
        component: component.Courses,
    },
    {
        name: 'lms.learner_results',
        path: '/lms/reports/learner_results',
        component: component.Courses,
    },
    {
        name: 'lms.reportdepartments',
        path: '/lms/reports/departments',
        component: component.Departments,
    },
    {
        name: 'lms.exported',
        path: '/lms/reports/exported_files',
        component: component.Exported,
    },
    {
        name: 'lms.reportlearners',
        path: '/lms/reports/learners',
        component: component.Learners,
    },
    {
        name: 'lms.reportdepartment_targets',
        path: '/lms/reports/department_targets',
        component: component.DepartmentTargets,
    },
    {
        name: 'lms.reporttarget_courses',
        path: '/lms/reports/target_courses',
        component: component.TargetCourses,
    },
    {
      name: 'lms.emaillogs',
      path: '/lms/sent-emails',
      component: component.Emaillogs,
    },
    {
      name: 'lms.teamslogs',
      path: '/lms/teams-notification-logs',
      component: component.Teamslogs,
    }
]



// WEBPACK FOOTER //
// ./src/app/lms/routes/index.js